<template>
  <div class="notification">
    <p class="total-title">
      <span>
        <svg class="icon" aria-hidden="true">
          <use xlink:href="#icon-dongtai"></use>
        </svg>
      </span>{{$t('dynamic')}}
    </p>

    <div class="main-info">
      <p v-if="messages.length === 0" class="text-center" id="no-messages">{{$t('noMessage')}}</p>
      <div v-else v-for="item in messages" @click="toggle(item)"
         :class="[item.show ? 'show-content' : 'not-show-content','a-dynamic']">
        <p class="time-and-title">
          <span class="time pull-left">{{ item.created_at | createFormatTime(item.created_at)}} </span>
          <br class="show-phone">
          <span :class="[{'not-complete': item.show},'little-title']">{{ item.title }}</span>
        </p>
        <p class="content">{{ item.content }}</p>
      </div>
      <show-more v-if="loadMore.show" @click.native="loadNotifications" :showSpinner="loadMore.showSpinner"></show-more>
    </div>

  </div>
</template>

<script>
  import {createFormatTime} from 'src/lib/filters'
  import ShowMore from '../../components/ShowMore.vue'
  import locales from './lang'

  export default {
    'name': 'notification-view',
    components: {ShowMore},
    filters: {createFormatTime},
    data: function () {
      return {
        isLoading: false,
        messages: [],
        dynamicPage: {
          'current_page': '0',
          'last_page': '1'
        },
        loadMore: {
          'nextPage': '',
          'showSpinner': false,
          'show': false
        }
      }
    },
    locales,
    beforeMount: function () {
      this.loadNotifications()
    },
    methods: {
      toggle: function (item) {
        item.show = !item.show
      },
      loadNotifications: function () {
        if (window.localStorage.getItem('token') === null) {
          return
        }
        this.loadMore.showSpinner = true
        if (this.dynamicPage.current_page < this.dynamicPage.last_page) {
          this.loadMore.nextPage = parseInt(this.dynamicPage.current_page) + 1
          this.$http.get('api/notifications', {
            params: {'page': this.loadMore.nextPage}
          }).then((response) => {
            this.loadMore.showSpinner = false
            this.dynamicPage = response.data.meta
            let originLength = this.messages.length > 0 ? this.messages.length : 0
            this.messages = this.messages.concat(response.body.data)
            for (let i = originLength; i < this.messages.length; i++) {
              this.messages[i].created_at = this.messages[i].created_at
              this.$set(this.messages[i], 'show', false)
            }
            if (this.dynamicPage.current_page < this.dynamicPage.last_page) {
              this.loadMore.nextPage = parseInt(this.dynamicPage.current_page) + 1
              this.loadMore.show = true
            } else {
              this.loadMore.show = false
            }
          })
        }
      }
    }
  }
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
  @import "../../assets/scss/variables";
  $base-spacing: 0.15rem;

  .show-phone {
    display: none;
  }

  .total-title {
    border-bottom: 1px solid $gray-light;
    color: $gray-darker;
    line-height: .43rem;
    margin: 0;
    padding: 0 0.14rem;
    .icon {
      height: 0.14rem;
      margin-right: $base-spacing;
      margin-left: $base-spacing;
      width: 0.14rem;
    }
  }

  .notification {
    background-color: white;
    border: 1px solid $gray-light;
    font-size: 0.14rem;
    max-height: 4.3rem;
    padding: 0;

    .main-info {
      height: 0.6rem*6;
      overflow-y: auto;
    }

    .a-dynamic {
      border-bottom: 1px solid $gray-light;
      cursor: pointer;
      margin: 0;
      padding: $base-spacing 0.25rem $base-spacing 0.29rem;
      &:hover {
        background-color: #fafafa;
      }
      span {
        line-height: .2rem;
        word-wrap: break-word;
        word-break: normal;
      }
      .time-and-title {
      }
      .time{
        color: #069da8;
        min-width: 0.86rem;
        padding: 0 $base-spacing 0 0;
      }
      .little-title {
        display: block;
      }
    }

    .not-complete {
      overflow-x: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }

    .not-show-content {
      .content {
        display: none;
      }
    }

    .show-content {
      .little-title {
        color: #069da8;
      }
      .content {
        display: inline;
      }
    }

    .show-more {
      border: 0;
      color: #069da8;
      cursor: pointer;
      margin: $base-spacing 0;
    }

    #no-messages {
      border: 0;
      color: $gray-dark;
      line-height: 4em;
    }
  }

  @media screen and (max-width: 767px) {
    .show-phone {
      display: inline;
    }
  }
</style>



// WEBPACK FOOTER //
// Notification.vue?2be93622